import { render, staticRenderFns } from "./Authorization.vue?vue&type=template&id=0c684dd7&"
import script from "./Authorization.vue?vue&type=script&lang=js&"
export * from "./Authorization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c684dd7')) {
      api.createRecord('0c684dd7', component.options)
    } else {
      api.reload('0c684dd7', component.options)
    }
    module.hot.accept("./Authorization.vue?vue&type=template&id=0c684dd7&", function () {
      api.rerender('0c684dd7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/index/components/Authorization.vue"
export default component.exports